// Copyright (C) 2017-2023 Smart code 203358507

const Addons = require('./Addons');

module.exports = Addons;
